// extracted by mini-css-extract-plugin
module.exports = {"list":"Tags_list__2nEqD","vertical":"Tags_vertical__8P3ob","listItem":"Tags_listItem__28GF6","active":"Tags_active__2Bdl4"};